import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormlySelectOption } from '@ngx-formly/core/select';
import { ValueLabel } from '../../builders/formly-builder.models';

export enum RadioTemplateType {
	DEFAULT,
	TAB
}

export type LuRadioSelectOption<T = any> = ValueLabel &
	Required<Pick<FormlySelectOption, 'value'>> & {
		value: T;
		icon?: string;
		description?: string;
		additionalFields?: FormlyFieldConfig[];
	};
